import React from 'react';

import { TextInput } from '@components/admin/Forms';
import { bookingInquiryStrings } from '@data/bookingInquiry';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    customerNoHint: () => (
      <>
        ＊契約番号、インボイス番号、PO NO、STYLE NOなどがあれば、
        <span>御社の管理用番号</span>
        を任意入力してください
      </>
    ),
    selectFile: 'ファイルを選択',
    selectFileCaution:
      '＊輸入商品の参考となる写真やカタログなどの資料をアップロードしてください。なお、仕様変更の有無にかかわらず通関時に再度商品説明用の画像をアップロードしていただく必要がございます。',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  customerInfoInputContainer: {
    ...common.flexColumn,
    padding: '1rem 1rem',
  },
  label: {
    width: 150,
  },
  inputTip: {
    ...common.textGray700,
    ...common.smallerText,
    margin: '0.25rem 0',
    paddingLeft: 170,
    '& span': {
      ...common.caution,
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  },
}));

export const CustomerInfoInput: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <div className={classes.customerInfoInputContainer}>
      <TextInput
        name="customer_no"
        label={bookingInquiryStrings.customerNo}
        formClasses={{
          label: classes.label,
        }}
      />
      <div className={classes.inputTip}>{strings.customerNoHint()}</div>

      <div style={{ height: 16 }} />
    </div>
  );
};
